export default {
  manufacturers: 'Manufacturers',
    rights: 'Roles',
    coupon: 'Coupons',
    images: 'Customer Images',
    datainit: 'Branch Init Data',
    templatedetails: 'Template Details',
    sharedimgs: 'Shared Patterns',
    orgdetails: 'Branch Details',
    productDetails: 'Pattern Details',
    clothSize: 'Sizes',
    ordersTitle: 'Orders',
    platformTitle: 'Platform',
    platform: {
      platforminfo: 'Platform Info',
      accounts: 'Accounts',
      defaultFunctions: 'New Store Defaults',
      orgrights: 'Branch Permissions',
      feedback: 'Feedback',
    },
    orders: {
      bokesOrder: 'E-Pattern Orders',
      clothsOrders: 'Ready-Made Orders',
      decorationOders: 'Accessory Orders',
      fabricsOrder: 'Fabric Orders',
      physicalBokes: 'Paper Pattern Orders',
      physicalPrinting: 'Paper Print',
      tailoredOrders: 'Measure Orders',
      tailoredBokes: 'Custom Pattern Orders',
      tailoredCloths: 'Custom Garment Orders',
      clothsOrder: 'Ready-Made Orders',
      tailoredMade: 'Tailor Custom Orders',
      tailoredMadeDetail: 'Tailor Custom Detail',
      videoTeching: 'Course Orders',
      takeOrders: 'Garment Orders',
      upgration: 'Membership Upgrade',
      autoscaleOrders: 'Smart Measure Orders'
    },
    customersTitle: 'Customers',
    customers: {
      customers: 'Customers',
      levels: 'Levels',
      notes: 'Coupons',
      extention: 'Renewal Review',
    },
    auditedTitle: 'Review',
    audited: {
      ref: 'Pattern Reference',
      shared: 'Pattern Sharing',
      settings: 'Review Settings',
      fabrics: 'Fabric Review',
      decorations: 'Accessory Review',
      bokes: 'Pattern Review',
      upShare: 'Sales Review'
    },
    productsTitle: 'Products',
    products: {
      bokes: 'Patterns',
      branchProducts: 'Patterns',
      cloths: 'Garments',
      clothDetails: 'Garment Details',
      parentSharedprds: 'Platform Products',
      upsharedProducts: 'Branch Sales',
      fabrics: 'Fabrics',
      upshare: 'List on Platform',
      fabricDetails: 'Fabric Details',
      accessories: 'Accessories',
      decorationDetails: 'Accessory Details',
      accessoryDetails: 'Accessory Details',
      decoration: 'Decorations',
      sharingFromOther: 'Branch Products',
      binding: 'Batch Binding',
      accessoriesDetails: 'Accessory Details'
    },
    systemTitle: 'Settings',
    system: {
      clothCategory: 'Categories',
      clothStyle: 'Styles',
      clothSize: 'Sizes',
      productUnit: 'Units',
      clothSizeViewer: 'Size Details',
      videos: 'Help Videos',
      settings: 'Parameters',
      operationLogs: 'Logs',
      fabricCategories: 'Fabric Categories',
      messages: 'Messages',
      clothSizeTemplate: 'Size Templates',
      depositeSettings: 'Recharge Settings',
      course: 'Courses',
      videoCategory: 'Video Categories'
    },
    inventoryTitle: 'Inventory',
    inventory: {
      storage: 'Stock',
      instore: 'Inbound',
      outstore: 'Outbound',
    },
    financialTitle: 'Finance',
    financial: {
      recharge: 'Purchase Records',
      myaccount: 'Fund Account',
      accountStatements: 'Transactions',
      withdrawal: 'Withdrawal',
      depositeRecords: 'Recharge Records',
      depositeHistories: 'Recharge Settings'
    },
    '新增':'Add','启用':'Enable','禁用':'Disable',
    '您确定要重置该机构的管理员密码吗？':'Reset admin password for this org?',
    '确认重置':'Confirm Reset','重置密码':'Reset Password',
    '接收':'On','不收':'Off','不可操作':'N/A',
    '新增账号':'New Account',
    '修改管理员密码':'Change Admin Password',
    '登录名:':'Login Name:','用户名:':'Username:','联系电话:':'Phone:',
    '登录密码:':'Password:','账户角色:':'Role:',
    '原始密码:':'Current Password:','新密码:':'New Password:','验证码:':'Code:',
    '请录入账号登录名!':'Please enter login name!','录入登录名':'Enter login name',
    '请录入录入用户名!':'Please enter username!','录入用户名':'Enter username',
    '请录入联系电话!':'Please enter phone!','录入联系电话':'Enter phone',
    '请录入录入密码!':'Please enter password!','录入密码':'Enter password',
    '请选择账户角色!':'Please select a role!',
    '请录入原始密码!':'Please enter current password!',
    '请录入短信验证码!':'Please enter code!',
    '获取验证码':'Get Code',
    '设置成功':'Saved','发送成功':'Sent',
    '密码已重置为123456':'Password reset to 123456',
    '请录入新密码!':'Please enter new password!',
    '密码至少6位，且包含字母与数字。':'Min 6 chars with letters and numbers.',
    '原始密码不正确。':'Current password incorrect.','密码修改成功。':'Password changed.',
    '账号添加成功。':'Account added.','账号添加失败：':'Failed to add: ',
    '账号修改成功。':'Account updated.','账号修改失败：':'Failed to update: ',
    '版型审核':'Pattern Review','面料审核':'Fabric Review','饰品审核':'Accessory Review',
    '系统添加':'System','管理员添加':'Admin',
    '图标':'Icon','手机号码':'Phone',
    '接收订单消息':'Order Msgs','接收审核消息':'Review Msgs',
    '角色':'Role','账号来源':'Source',
    '创建时间':'Created','最后登录时间':'Last Login',
    '秒后重新获取':'s to retry',
    '登录名、手机号码、用户名':'Login name, phone, or username',
    '雨滴':'Raindrop',
    '修改了超级管理员密码':'Changed super admin password',
    '个人信息':'Profile','更新图标':'Update Icon','个人资料':'Profile',
    '登录名':'Login Name','用户名':'Username','手机号':'Phone','登录时间':'Login Time',
    '所属机构':'Organization','机构类型':'Org Type','编辑个人信息':'Edit Profile',
    '请输入昵称!':'Please enter nickname!','请输入手机号!':'Please enter phone!',
    '所属机构:':'Organization:','保存更改':'Save Changes','机构信息':'Org Info',
    'LOGO白:':'LOGO White:','LOGO黑:':'LOGO Dark:','客服链接:':'Service Link:',
    '机构全称:':'Full Name:','请输入机构全称!':'Please enter full name!',
    '网站地址:':'Website:','机构简称:':'Short Name:','请输入机构简称!':'Please enter short name!',
    '营业执照号:':'License No:','请输入营业执照号!':'Please enter license no!',
    '营业执照:':'License:','机构所在地:':'Location:','请输入机构所在地!':'Please enter location!',
    '机构责任人:':'Contact Person:','请输入机构责任人!':'Please enter contact person!',
    '责任人电话:':'Contact Phone:','请输入责任人电话!':'Please enter contact phone!',
    '责任人证件号:':'ID Number:','请输入责任人身份证号!':'Please enter ID number!',
    '注册类型:':'Reg Type:','微信子商户号:':'WeChat Sub-Merchant:','微信APPID:':'WeChat APPID:',
    '您确定要删除该配置吗，删除后将会影响系统正常支付？':'Delete this config? It will affect payment.',
    '未配置':'Not Configured','扫码绑定打单员':'Scan to Bind Printer',
    '首页设置':'Home Settings','首页标题:':'Home Title:','请输入首页标题!':'Please enter home title!',
    '首页描述:':'Home Desc:','请输入首页描述!':'Please enter home description!',
    '首页图片:':'Home Image:','绑定发货物流':'Bind Shipping',
    '绑定新物流公司':'Add Logistics Co.','微信支付':'WeChat Pay',
    '分账账户':'Settlement Account','开通微信支付':'Enable WeChat Pay',
    '请输入微信子商户号!':'Please enter sub-merchant no!','请输入微信APPID!':'Please enter WeChat APPID!',
    '绑定物流公司':'Bind Logistics Co.','物流公司:':'Logistics Co:','请选择物流公司!':'Please select logistics!',
    '请选择物流公司':'Select logistics','物流账号:':'Logistics Account:','请录入物流账号!':'Please enter logistics account!',
    '请录入物流账号':'Enter logistics account','绑定密码:':'Bind Password:',
    '绑定失败：':'Bind failed: ',
    '解除绑定失败：':'Unbind failed: ','解除绑定成功':'Unbind succeeded',
    '代码':'Code','附加码':'Extra Code','添加时间':'Added',
    '域名已存在':'Domain exists',
    '图片尺寸太小，不符合要求，至少50*50，且长宽比为1:1':'Image too small, min 50*50, ratio 1:1',
    '图片尺寸太大，不符合要求，宽高不能超过800*800，且长宽比为1:1':'Image too large, max 800*800, ratio 1:1',
    '编辑个人账户信息':'Edit Personal Info','保存失败，手机号码可能已使用！':'Save failed, phone may be in use!',
    '请录入正确的域名地址，不包含http/https,例demo':'Enter domain without http/https, e.g. demo',
    '更新成功':'Updated','更新失败，请稍后再次尝试。':'Update failed, please retry.',
    'LOGO图片不符合要求,请重新选择。':'LOGO does not meet requirements, please reselect.',
    '编辑机构信息':'Edit Org Info','保存成功':'Saved',
    '企业':'Enterprise','个人':'Personal',
    '请输入客户姓名、手机号码开始查询':'Search name or phone','客户类别':'Category',
    '会员级别':'Level','导出号码':'Export Phone','个':'',
    '新增会员':'New Member','会员昵称:':'Nickname:','请录入会员昵称!':'Enter nickname!',
    '密码:':'Password:','如不输入，密码默认123456':'Default: 123456',
    '手机号码:':'Phone:','会员等级:':'Level:','会员长度':'Term','会员长度:':'Term:',
    '会员续期':'Renewal','续期长度:':'Renewal Term:','请选择续期长度!':'Select renewal term!',
    '一个月':'1 Month','三个月':'3 Months','六个月':'6 Months','一年':'1 Year','两年':'2 Years','三年':'3 Years',
    '自定义':'Custom','续期长度':'Renewal Term','到期时间:':'Expiry:','请选择到期截止时间!':'Select expiry date!',
    '续期方式:':'Renewal Type:','请选择续期方式!':'Select renewal type!',
    '对公汇款购买升级':'Bank Transfer Upgrade','会员延期':'Extension','其它':'Other','续期方式':'Renewal Type',
    '备注:':'Remark:','续期备注':'Renewal Note','手动续期':'Manual Renewal',
    '续版数量:':'Renewal Qty:','请录入续版数量!':'Enter renewal qty!',
    '支付金额:':'Amount:','支付金额!':'Enter amount!','续期时长:':'Duration:','请选择续期长度':'Select duration',
    '截止时间:':'Deadline:','请录入过期结止时间!':'Enter expiry date!',
    '手动延期':'Manual Extension','对公转账':'Bank Transfer','线下转账':'Offline Transfer',
    '您确定要删除这个客户吗？删除后不可恢复！':'Delete this customer? Cannot be undone!',
    '发券':'Issue Coupon','退卡':'Refund','你确定要':'Are you sure to ','该账号吗？':' this account?',
    '你确定要重置该账号密码吗？默认密码为123456':'Reset password to 123456?',
    '会员备注':'Member Notes','更新备注':'Update Note','会员续期记录':'Renewal Records',
    '序号':'No.','时长':'Duration','续期时间':'Renewal Time','操作员':'Operator',
    '个月':' Months','驳回:':'Rejected:','续期通过':'Approved','待支付':'Pending','天':'d',
    '您确定将当前账号解除黑名单吗？':'Remove from blacklist?',
    '您确定将当前账号拉入黑名单吗？':'Add to blacklist?',
    '充值':'Recharge','消费':'Consume','退费':'Refund',
    '变更会员级别':'Change Level','请选择一个会员级别!':'Select a level!',
    '从一般会员升级为会员，过期日期为当天，请及时为会员续期。':'Upgraded. Expiry is today, please renew.',
    '储值账户退款':'Deposit Refund','账户本金':'Principal','请录入退款金额!':'Enter refund amount!',
    '剩余赠额':'Gift Balance','已用赠额':'Gift Used','实退金额':'Refund Amount',
    '退款说明':'Refund Note','请录入退款说明!':'Enter refund note!','确定退卡':'Confirm Refund',
    '下载限制':'Download Limit','单日下载限制:':'Daily Limit:','单日最大下载限制数量!':'Enter daily limit!',
    '失效日期:':'Expire Date:','请录入失效日期!':'Enter expire date!',
    '失效时间:':'Expire Time:','请录入失效时间!':'Enter expire time!','说明':'Note',
    '1、限制会员单日下载电子版型数量。':'1. Limits daily e-pattern downloads.',
    '2、为0，此设置不限制。':'2. 0 means no limit.',
    '3、不为0且在有限时间内，会限制。':'3. Non-zero within time range will limit.',
    '4、该限制优先于全局限制。':'4. Overrides global limit.',
    '发放优惠券':'Issue Coupon','券名称:':'Coupon:',
    '普通会员':'Regular','3个月':'3M','6个月':'6M','12个月':'12M','终身':'Lifetime',
    '客户充值/消费明细':'Recharge/Consumption Details','订单号':'Order No.','充值金额':'Recharge',
    '赠送金额':'Gift','充值时间':'Recharge Time','类型':'Type',
    '下载余量':'Download Quota','账户余额':'Balance','会员过期时间':'Expiry',
    '过期天数':'Days Left','备注':'Remark','黑名单':'Blacklist',
    '1个月':'1M','2个月':'2M','半年':'6M','二年':'2Y','四年':'4Y','五年':'5Y',
    '未过期':'Active','已过期':'Expired','30天内过期':'Expiring 30d','已禁用':'Disabled','储值用户':'Deposit User',
    '实退金额不能小于0!':'Refund cannot be negative!',
    '发放成功':'Issued','当前客户不符合该券的发放要求，发放失败！':'Customer does not meet coupon requirements!',
    '请选择需要发放的优惠券！':'Select a coupon!','备注更新成功':'Note updated',
    '本金':'Principal','已使用赠额':'Gift Used','实退':'Refund',
    '退卡成功':'Refunded','其它会员':'Other Member',
    '新增客户:':'New Customer:','客户新增成功':'Customer added',
    '账号：':'Account: ','的密码':' password','重置密码成功！':'Password reset!',
    '当前客户有未完成的会员续期单据，请完成后再发起续期。':'Pending renewal exists. Complete it first.',
    '续期成功':'Renewed','续期会员':'Renewed member','的有效期':' validity',
    '设置账号的下载限制':'Set download limit',
    '最后登录时间倒序':'Last Login Desc','会员过期时间倒序':'Expiry Desc','会员创建时间倒序':'Created Desc',
    '面料折扣': 'Fabric Discount',
    '购买时长': 'Duration',
    '购买金额': 'Amount',
    '店主购买金额': 'Owner Amount',
    '所衣折扣': 'Garment Discount',
    '饰品折扣': 'Accessory Discount',
    '辅料折扣': 'Material Discount',
    '可下载数量': 'Download Limit',
    '等级名称': 'Level Name',
    '成衣定制折扣': 'Custom Garment Discount',
    '成衣现货折扣': 'Ready-Made Discount',
    '版型下载数量': 'Pattern Download Limit',
    '购买时长(月)': 'Duration(Months)',
    '终端客户购买金额': 'Customer Amount',
    '编辑会员等级': 'Edit Level ',
    '的数据': ' Data',
    '保存成功！': 'Saved!',
    '优惠券设置': 'Coupon Settings',
    '请录入券名称!': 'Please enter coupon name!',
    '请录入券名称，如双十一活动券。': 'e.g. Double 11 Coupon',
    '券类型:': 'Type:',
    '请选择券类型!': 'Please select coupon type!',
    '推荐用户券': 'Referral',
    '活动券': 'Promo',
    '用户券': 'User',
    '核销对象:': 'Targets:',
    '请录入核销对象!': 'Please enter targets!',
    '受众范围:': 'Scope:',
    '请录入受众范围!': 'Please enter scope!',
    '使用门槛:': 'Threshold:',
    '请录入使用门槛!': 'Please enter threshold!',
    '请录入券的最低使用门槛金额。': 'Min. spend amount',
    '券面金额:': 'Amount:',
    '请录入券面金额!': 'Please enter amount!',
    '请录入券面金额。': 'Coupon face value',
    '券有效期:': 'Validity:',
    '请录入券有效时间范围!': 'Please enter validity period!',
    '开始日期': 'Start Date',
    '结束日期': 'End Date',
    '所有券清单': 'All Coupons',
    '停用': 'Disable',
    '设置': 'Edit',
    '确定要删除当前券吗，删除后不可恢复？': 'Delete this coupon? This cannot be undone.',
    '券已过期': 'Expired',
    '消费金额超过': 'Spend over ',
    '已发券清单': 'Issued',
    '发放券': 'Dispatch',
    '未设': 'None',
    '最近一个月未登录': 'No login in 1 month',
    '最近两个月未登录': 'No login in 2 months',
    '最近三个月未登录': 'No login in 3 months',
    '半年未登录': 'No login in 6 months',
    '最近一个月未下单': 'No order in 1 month',
    '最近两个月未下单': 'No order in 2 months',
    '最近三个月未下单': 'No order in 3 months',
    '半年未下单': 'No order in 6 months',
    '会员数:': 'Members:',
    '不重复发放': 'No duplicate',
    '券名称': 'Coupon Name',
    '发放': 'Dispatch',
    '定向生效': 'Targeted',
    '生效周期': 'Cycle',
    '券面金额': 'Amount',
    '受众范围': 'Scope',
    '使用门槛': 'Threshold',
    '开始时间': 'Start',
    '截止时间': 'End',
    '过期时间': 'Expires',
    '累计订单': 'Orders',
    '最后下单时间': 'Last Order',
    '客户': 'Customer',
    '来源': 'Source',
    '发放类型': 'Type',
    '发生时间': 'Time',
    '新增优惠券': 'New Coupon',
    '券类型': 'Type',
    '导出': 'Export',
    '订单列表': 'Order List',
    '支付宝支付': 'Alipay',
    '线下支付': 'Offline Pay',
    '余额支付': 'Balance Pay',
    '退款': 'Refund',
    '确定要作废这个订单吗？': 'Void this order?',
    '作废': 'Void',
    '客户分组': 'Customer Group',
    '订单详情': 'Order Details',
    '客户信息': 'Customer Info',
    '客户姓名': 'Customer Name',
    '联系电话': 'Phone',
    '下单时间': 'Order Time',
    '版型号': 'Pattern No.',
    '数量': 'Qty',
    '订单金额': 'Order Amount',
    '券抵扣': 'Coupon Deduction',
    '版型退款': 'Pattern Refund',
    '退款人': 'Refund By',
    '退款时间': 'Refund Time',
    '留言': 'Message',
    '购买尺码': 'Size',
    '尺码数据': 'Size Data',
    '电话': 'Phone',
    '商品名称': 'Product Name',
    '附件': 'Attachment',
    '尺码': 'Size',
    '评分': 'Rating',
    '店面信息': 'Store Info',
    '订单数量': 'Order Count',
    '门店信息': 'Store Info',
    '电子版型订单': 'E-Pattern Orders',
    '的订单': "'s Orders",
    '复制成功': 'Copied!',
    '无': 'None',
    '订单作废成功！': 'Order voided!',
    '管理员版型退款': 'Admin pattern refund',
    '退款成功': 'Refund success',
    '全部': 'All',
    '客户姓名/手机号/订单号': 'Name/Phone/Order No.',
    '请输入编码、系统编码、版型标题查询': 'Enter code, system code, or pattern title',
  '服装类别': 'Clothing Category',
  '版型/定制': 'Pattern/Custom',
  '添加版型': 'Add Pattern',
  '版型列表': 'Pattern List',
  '版型共享': 'Pattern Sharing',
  '全选': 'Select All',
  '点击开通成衣量体定制': 'Click to enable garment customization',
  '点击修改量体定制价格': 'Click to modify custom price',
  '下载版型': 'Download Pattern',
  '所有面料饰品': 'All Fabrics & Accessories',
  '没有绑定面料或饰品': 'No fabrics or accessories bound',
  '面料饰品': 'Fabrics & Accessories',
  '制版师机构列表': 'Pattern Maker Org List',
  '提交': 'Submit',
  '颜色：': 'Color:',
  '成衣定制上下架': 'Garment Custom List/Delist',
  '恢复': 'Restore',
  '已删除': 'Deleted',
  '面料名称': 'Fabric Name',
  '面料名称：': 'Fabric Name:',
  '请录入面料名称!': 'Please enter fabric name!',
  '请引用面料  →': 'Please reference fabric →',
  '引用面料': 'Reference Fabric',
  '面料颜色：': 'Fabric Color:',
  '请引用面料': 'Please reference fabric',
  '面料款号：': 'Fabric Code:',
  '请录入面料款号!': 'Please enter fabric code!',
  '成衣定制标题：': 'Custom Title:',
  '请录入成衣成衣定制标题!': 'Please enter custom title!',
  '成衣生产加工费：': 'Production Cost:',
  '客户定制成衣价：': 'Customer Custom Price:',
  '会员定制成衣价：': 'Member Custom Price:',
  '成衣定制说明：': 'Custom Description:',
  '请录入成衣描述!': 'Please enter description!',
  '请在此录入成衣定制描述': 'Enter garment custom description',
  '新增面料': 'New Fabric',
  '版型组套': 'Pattern Group',
  '请输入版型标题，代码进行检索': 'Enter pattern title or code',
  '版型类别': 'Pattern Category',
  '审核还未开始，暂无数据。': 'Audit not started yet.',
  '版型浏览': 'Pattern Browse',
  '版型基本信息': 'Pattern Info',
  '版型标题': 'Pattern Title',
  '版型款号': 'Pattern Code',
  '版型价格': 'Pattern Price',
  '服装分类': 'Clothing Category',
  '版型描述': 'Pattern Description',
  '成衣描述': 'Garment Description',
  '版型图片': 'Pattern Images',
  '版型文件': 'Pattern Files',
  '面料信息': 'Fabric Info',
  '面料': 'Fabric',
  '配饰信息': 'Accessory Info',
  '配饰': 'Accessory',
  '流程浏览': 'Process Browse',
  '电子版型': 'Digital Pattern',
  '绑定': 'Binding',
  '恢复成功': 'Restored',
  '开通成功！': 'Activated!',
  '只有开通了成衣定制了才能上下架产品。': 'Enable garment custom first.',
  '账号已停用或绑定错误。': 'Account disabled or binding error.',
  '提交共享成功': 'Sharing submitted',
  '新面料': 'New Fabric',
  '饰品名称:': 'Accessory Name:',
  '请录入饰品名称!': 'Please enter accessory name!',
  '饰品颜色:': 'Accessory Color:',
  '请录入饰品颜色!': 'Please enter accessory color!',
  '饰品款号:': 'Accessory No.:',
  '请录入饰品款号!': 'Please enter accessory No.!',
  '饰品类别:': 'Accessory Category:',
  '请选择饰品类别!': 'Please select accessory category!',
  '成本价格:': 'Cost Price:',
  '请录入商品成本价格!': 'Please enter cost price!',
  '分销价格:': 'Wholesale Price:',
  '请录入商品分销价格!': 'Please enter wholesale price!',
  '销售价格:': 'Sale Price:',
  '请录入商品销售价格!': 'Please enter sale price!',
  '会员价格:': 'Member Price:',
  '请录入商品会员价格!': 'Please enter member price!',
  '销售单位:': 'Sale Unit:',
  '请录入销售单位!': 'Please enter sale unit!',
  '商品描述:': 'Product Description:',
  '请录入商品描述!': 'Please enter product description!',
  '请在此录入商品描述': 'Please enter product description here',
  '单击选择': 'Click to select',
  '一个或多个文件上传': 'one or more files to upload',
  '上传的文件将按文件扩展自动分类': 'Uploaded files will be auto-classified by extension',
  '图片文件': 'Image Files',
  '商品信息': 'Product Info',
  '保存': 'Save',
  '审核受理中，不可编辑': 'Under review, cannot edit',
  '已审核,不可编辑': 'Reviewed, cannot edit',
  '保存并提交审核': 'Save & Submit for Review',
  '解除审核': 'Release Review',
  '撤销审核申请': 'Revoke Review',
  '返回': 'Back',
  '解锁成功': 'Unlocked',
  '撤销成功': 'Revoked',
  '撤销失败,当前状态不能被撤销。': 'Revoke failed, current status cannot be revoked.',
  '当前账号没有该权限，请联系管理理员': 'No permission, please contact admin',
  '图片删除成功': 'Image deleted',
  '审核通过。': 'Review passed.',
  '提交成功': 'Submitted',
  '饰品新增成功': 'Accessory added',
  '饰品保存成功': 'Accessory saved',
  '请输入编码、系统编码、饰品标题查询': 'Search by code, system code, accessory title',
  '商品共享': 'Product Sharing',
  '共享': 'Share',
  '不共享': 'Not Share',
  '饰品范围': 'Accessory Range',
  '所有饰品': 'All Accessories',
  '上级饰品': 'Parent Accessories',
  '本店饰品': 'Store Accessories',
  '批量上下架': 'Batch List/Delist',
  '查询': 'Search',
  '添加饰品': 'Add Accessory',
  '缩图': 'Thumb',
  '平台编号': 'Platform No.',
  '款号': 'Style No.',
  '状态': 'Status',
  '标题': 'Title',
  '颜色': 'Color',
  '库存数': 'Stock',
  '销售价': 'Sale Price',
  '所属门店': 'Store',
  '上下架时间': 'List/Delist Time',
  '最后修改人': 'Last Modified By',
  '操作': 'Action',
  '修改上架时间': 'Modify Listing Time',
  '确定': 'Confirm',
  '取消': 'Cancel',
  '待审核': 'Pending',
  '已审核': 'Reviewed',
  '已驳回': 'Rejected',
  '审核中': 'Reviewing',
  '上架平台': 'Listed',
  '未通过': 'Failed',
  '下架平台': 'Delist',
  '上架': 'List',
  '下架': 'Delist',
  '编辑': 'Edit',
  '查看': 'View',
  '删除': 'Delete',
  '加颜色': 'Add Color',
  '设为头版': 'Set as Cover',
  '添加饰品颜色': 'Add Accessory Color',
  '饰品标题:': 'Accessory Title:',
  '请录入饰品标题!': 'Please enter accessory title!',
  '饰品编号:': 'Accessory No.:',
  '饰品单位:': 'Accessory Unit:',
  '请录入PLT文件价格!': 'Please enter PLT price!',
  '请录入成本价格!': 'Please enter cost price!',
  '请录入销售价格!': 'Please enter sale price!',
  '确定删除该图片吗？': 'Delete this image?',
  '请选择需要添加的版型。': 'Please select a pattern to add.',
  '审核详情': 'Review Details',
  '审核尚未开始': 'Review not started',
  '不通过': 'Failed',
  '通过': 'Passed',
  '原因：': 'Reason:',
  '审核附件': 'Review Attachments',
  '关闭': 'Close',
  '引用': 'Reference',
  '标题：': 'Title:',
  '请录入版型标题：!': 'Please enter pattern title!',
  '销售价：': 'Sale Price:',
  '会员价：': 'Member Price:',
  '分销价：': 'Wholesale Price:',
  '版型说明：': 'Pattern Note:',
  '请在入版型描述!': 'Please enter pattern description!',
  '请在此录入版型描述': 'Please enter pattern description here',
  '更新': 'Update',
  '删除商品': 'Delete Product',
  '您确认删除该商品吗？删除后不可恢复！！': 'Confirm delete? Cannot be recovered!',
  '请勾选需要批量上下架的产品': 'Select products to list/delist',
  '上级店面的商品': 'Parent Store Products',
  '自已创建的商品': 'My Products',
  '批量上架': 'Batch List',
  '批量下架': 'Batch Delist',
  '删除成功！': 'Deleted!',
  '设置封面成功。': 'Cover set.',
  '操作成功': 'Done',
  '面料标题:': 'Fabric Title:',
  '请录入面料标题!': 'Please enter fabric title!',
  '面料颜色:': 'Fabric Color:',
  '请录入面料颜色!': 'Please enter fabric color!',
  '面料编号:': 'Fabric No.:',
  '面料单位:': 'Fabric Unit:',
  '请输入编码、系统编码、成衣标题查询': 'Search by code, system code, garment title',
  '面料范围': 'Fabric Range',
  '所有面料': 'All Fabrics',
  '上级面料': 'Parent Fabrics',
  '本店面料': 'Store Fabrics',
  '添加面料': 'Add Fabric',
  '创建组套': 'Create Set',
  '保存组套': 'Save Set',
  '取消组套': 'Cancel Set',
  '绑定成衣': 'Bind Garment',
  '添加面料颜色': 'Add Fabric Color',
  '输入关键字查询成衣': 'Search garment by keyword',
  '编号': 'No.',
  '上架时间': 'Listing Time',
  '成衣组套': 'Garment Set',
  '输入编号标题开始查询': 'Search by code or title',
  '选择': 'Select',
  '确认组套': 'Confirm Set',
  '宽度': 'Width',
  '米': 'm',
  '解套': 'Unset',
  '组套': 'Set',
  '确认绑定': 'Confirm Bind',
  '下一步': 'Next',
  '上一步': 'Prev',
  '删除成功': 'Deleted',
  '共享成功': 'Shared',
  '取消共享成功': 'Unshared',
  '设置成功。': 'Set.',
  '版型更新成功': 'Pattern updated',
  '面料新增成功': 'Fabric added',
  '请录入正确的价格!': 'Please enter valid price!',
  '元': 'CNY',
  '博克CAD-PLT-尺码文件': 'CAD-PLT-Size Files',
  '打包下载': 'Download All',
  '版型信息': 'Pattern Info',
  '绑定面料': 'Bind Fabric',
  '绑定配饰': 'Bind Accessory',
  '上传的EXCEL尺码与所选择的尺码类型不匹配': 'Excel sizes mismatch with selected size type',
  '尺码匹配错误': 'Size Mismatch',
  '缺失': 'Missing',
  '忽略': 'Ignore',
  '正在下载文件中，请稍后……': 'Downloading, please wait...',
  '尺码更新成功': 'Size updated',
  '当前账号没有编辑权限，请联系管理员。': 'No edit permission, contact admin.',
  '文件删除成功': 'File deleted',
  '已存在，不能重复添加': 'already exists, cannot add again',
  '上传失败': 'Upload failed',
  '尺码数据匹配错误，请修改后再保存！': 'Size data mismatch, please fix before saving!',
  '版型新增成功': 'Pattern added',
  '版型保存成功': 'Pattern saved',
  '版型保存失败': 'Pattern save failed',
  '面料商:': 'Fabric Supplier:',
  '运单信息:': 'Waybill Info:',
  '运单号:': 'Waybill No.:',
  '服装标题:': 'Garment Title:',
  '请录入服装标题!': 'Please enter garment title!',
  '服装款号:': 'Garment No.:',
  '请录入服装编号!': 'Please enter garment No.!',
  'PLT文件价格:': 'PLT Price:',
  '版型分销价格:': 'Pattern Wholesale:',
  '服装风格:': 'Garment Style:',
  '服装分类:': 'Garment Category:',
  '尺码类型:': 'Size Type:',
  '请选择尺码表类别': 'Please select size chart',
  '适应季节:': 'Season:',
  '春': 'Spring',
  '夏': 'Summer',
  '秋': 'Autumn',
  '冬': 'Winter',
  '版型调整视频:': 'Pattern Video:',
  '上传视频': 'Upload Video',
  '浏览视频': 'Play Video',
  '动态短视频:': 'Short Video:',
  '请录入动态短视频!': 'Please enter short video!',
  '版型描述:': 'Pattern Description:',
  '请录入录入版型描述!': 'Please enter pattern description!',
  '查看视频': 'View Video',
  '上下架': 'List/Delist',
  '是否共享': 'Shared',
  '平台售卖': 'Platform Sales',
  '服装版型': 'Pattern',
  '成衣定制': 'Custom Garment',
  '该产品处于上架中，不可删除！': 'Product is listed, cannot delete!',
  '该产品处于共享中，不可删除！': 'Product is shared, cannot delete!',
  '请先删除子项！': 'Please delete sub-items first!',
  '只有审核通过的产品才能上架产品。': 'Only reviewed products can be listed.',
  '该产品已停止共享，暂不可上架！': 'Product sharing stopped, cannot list!',
  '原店面已将该产品下架，暂不可上架！': 'Parent store delisted this product!',
  '上架成功！': 'Listed!',
  '下架成功！': 'Delisted!',
  '平台上架提交成功。': 'Platform listing submitted.',
  '平台上架取消成功。': 'Platform listing cancelled.',
  '成组成功': 'Grouped',
  '请至少勾选两个项目进行组套！': 'Select at least 2 items to group!',
  '取消成组成功。': 'Ungrouped.',
  '解套成功。': 'Unset.',
  '绑定成功': 'Bound',
  '当前版型已经绑定了其它成衣，不再能再次绑定了。': 'Pattern already bound to another garment.',
  '绑定失败': 'Bind failed',
  '解绑成功': 'Unbound',
  '分类': 'Category',
  '图片': 'Image',
  'PLT价': 'PLT Price',
  'BOKE价': 'BOKE Price',
  '客户取货方式': 'Pickup Method',
    '邮寄': 'Mail',
    '收货地址': 'Address',
    '顺丰ID': 'SF ID',
    '物流信息': 'Logistics',
    '物流公司': 'Courier',
    '发货': 'Ship',
    '收货人': 'Receiver',
    '收货人电话': 'Receiver Phone',
    '联系方式': 'Contact',
    '售后订单': 'After-sales',
    '预售订单': 'Pre-sale',
    '详情': 'Details',
    '处理': 'Process',
    '待接收订单': 'Pending Orders',
    '已接收订单': 'Accepted Orders',
    '手动派单': 'Manual Dispatch',
    '平台版师': 'Platform Designer',
    '入驻版师': 'Designer',
    '支付时间': 'Pay Time',
    '商品退款': 'Product Refund',
    '邮寄费用': 'Shipping Fee',
    '退邮寄费': 'Shipping Refund',
    '券减免': 'Coupon Discount',
    '售后事项': 'After-sales',
    '退款商品': 'Refund Product',
    '货物状态': 'Goods Status',
    '退款原因': 'Refund Reason',
    '退款金额': 'Refund Amt',
    '相关图片': 'Photos',
    '同意退款': 'Approve',
    '拒绝退款': 'Reject',
    '签收货物': 'Confirm Receipt',
    '确认签收': 'Confirm Receipt',
    '确认退款': 'Confirm Refund',
    '确定要作废这个订单吗': 'Void this order?',
    '视频安装': 'Video Install',
    '安装时间': 'Install Time',
    '安装人': 'Installer',
    '安装状态': 'Install Status',
    '安装备注': 'Install Note',
    '请选择安装时间': 'Select install time',
    '请选择安装人': 'Select installer',
    '请选择安装状态': 'Select install status',
    '课程退款': 'Course Refund',
    '课程名称': 'Course',
    '支付并开通': 'Pay & Activate',
    '修改价格': 'Edit Price',
    '原始订单金额': 'Original Amt',
    '新订单金额': 'New Amt',
    '已开通': 'Activated',
    '已提交': 'Submitted',
    '已支付': 'Paid',
    '已作废': 'Voided',
    '刷新': 'Refresh',
    '当前没有未派送的订单': 'No pending orders',
    '成衣图片': 'Product Image',
    '客户体型': 'Body Meas.',
    '暂无客户体型图片': 'No body images',
    '饰品信息': 'Accessory Info',
    '抢单': 'Accept',
    '自动匹配': 'Auto Match',
    '撤销更改': 'Undo',
    '保存量体尺码': 'Save Sizes',
    '正在下载文件中请稍后': 'Downloading, please wait...',
    '加载中': 'Loading...',
    '下载当前客户版型': 'Download Pattern',
    '下载团体客户版型': 'Download Group Pattern',
    '产品标题': 'Product',
    '下载': 'Download',
    '成衣型号': 'Model',
    '售后状态': 'After-sales',
    '订单状态': 'Order Status',
    '退款发起日期': 'Refund Date',
    '货运信息': 'Shipping Info',
    '面料号': 'Fabric No.',
    '饰品号': 'Accessory No.',
    '我的订单': 'My Orders',
    '专属版型': 'Exclusive',
    '新增订单': 'New Order',
    '纸质版型': 'Paper Pattern',
    '线下量体': 'Offline Measure',
    '下载团体客户数据': 'Download Group Data',
    '面料订单': 'Fabric Orders',
    '辅料订单': 'Accessory Orders',
    '账户支付': 'Account Pay',
    '已取件': 'Picked Up',
    '运输中': 'In Transit',
    '已签收': 'Signed',
    '已发货': 'Shipped',
    '待发货': 'Pending',
    '多状态': 'Multi',
    '运单号': 'Tracking No.',
    '送至': 'Deliver to',
    '设置顺丰ID': 'Set SF ID',
    '请录入顺丰ID': 'Enter SF ID',
    '邮费': 'Shipping',
    '打印费': 'Print Fee',
    '退打印费': 'Print Refund',
    '已完成打印': 'Done Print',
    '已打印': 'Printed',
    '打印': 'Print',
    '订单已发货': 'Shipped!',
    '版型已打印': 'Printed!',
    '未收到货': 'Not Received',
    '已收到货': 'Received',
    '不想要了': 'No longer needed',
    '协商一致退款': 'Mutual agreement',
    '空包裹': 'Empty package',
    '快递一直未送到': 'Not delivered',
    '商品破损已拒签': 'Damaged, rejected',
    '客户申请退货退款': 'Return requested',
    '买家退货': 'Buyer return',
    '退款完毕': 'Refund done',
    '客户寄回货物': 'Customer return',
    '商家同意退货': 'Seller approved',
    '等待接收退货说明': 'Waiting for returned goods.',
    '商家拒绝退货': 'Seller rejected',
    '拒绝原因': 'Reject reason',
    '回复时间': 'Reply time',
    '商家已退款': 'Refunded',
    '退款成功时间': 'Refund time',
    '请录入拒绝原因': 'Enter reject reason',
    '确认签收并退款': 'Confirm & Refund',
    '确认签收提示': 'Confirm receipt and refund?',
    '确认退款提示': 'Order not shipped, refund total',
    '您确认退款吗': 'Confirm refund?',
    '收件人': 'Receiver:',
    '收件人电话': 'Receiver Phone:',
    '收件地址': 'Address:',
    '物流信息标签': 'Logistics:',
    '原订单号': 'Original Order:',
    '商品货号': 'Product No.:',
    '退款失败': 'Refund failed',
    '全部门店': 'All Stores',
    '自营平台': 'Platform',
    '重置': 'Reset',
    '批次号': 'Batch No.',
    '量体类型': 'Measure Type',
    '下载个人': 'Download',
    '下载团体': 'Group DL',
    '打印清单': 'Print List',
    '收件人标签': 'Receiver',
    '联系电话标签': 'Phone',
    '收件地址标签': 'Address',
    '购买版型': 'Buy Pattern',
    '购买尺码标签': 'Size',
    '微信扫码查看小程序': 'Scan for Mini Program',
    '微信扫码联系客服': 'Scan for Support',
    '微信扫码查看细节': 'Scan for Details',
    '面料生产提示': 'Choose similar fabrics for best results.',
    '电话标签': 'Phone',
    '网址': 'Website',
    '总接单': 'Total:',
    '今接单': 'Today:',
    '总': 'Total',
    '今': 'Today',
    '请选择需要回复的信息': 'Select reply',
    '输入消息内容': 'Enter message',
    '请输入金额': 'Enter amount',
    '发送': 'Send',
    '出价': 'Quote',
    '咨询': 'Inquiry',
    '企微': 'WeCom',
    '结束': 'End',
    '是否继续': 'Close after-sales order?',
    '是': 'Yes',
    '否': 'No',
    '订单已确认等待付款': 'Order confirmed, awaiting payment.',
    '订单已付款等待发布': 'Paid, awaiting pattern.',
    '请选择待派送订单': 'Select order to dispatch!',
    '请输入物流单号': 'Enter tracking no.',
    '定制图片': 'Custom Images',
    '定制尺码': 'Custom Size',
    '上传附件': 'Upload',
    '请将BOKE文件打包上传': 'Upload BOKE+Size+PLT files',
    '购买版型按钮': 'Buy Pattern',
    '线下预约量体': 'Offline Appointment',
    '面料商': 'Fabric Supplier',
    '金额': 'Amount',
    '公司': 'Company',
    '生产商': 'Manufacturer',
    '成衣生产商': 'Garment Mfr.',
    '输入生产商': 'Enter manufacturer',
    '总接单数': 'Total:',
    '今日接单': 'Today:',
    '待发货标签': 'Pending',
    '到店自取': 'Pickup',
    '物流': 'Logistics:',
    '单号': 'No.:',
    '查看详情': 'Details',
    '接收订单': 'Accept',
    '确定要撤回这个订单吗': 'Withdraw this order?',
    '撤回': 'Withdraw',
    '加工费/生产商': 'Fee/Manufacturer',
    '订单来源': 'Order Source',
    '订单信息': 'Order Info',
    '版型类型': 'Pattern Type',
    '价格': 'Price',
    '总金额': 'Total',
    '名称': 'Name',
    '在线下载': 'Online Download',
    '相同地址合并发货': 'Combine same address',
    '联系地址': 'Address',
    '点击查看详情': 'View details',
    '点击上传版型': 'Upload pattern',
    '点击删除已上传的版型文件': 'Delete uploaded pattern',
    '点击下载订单文件': 'Download order file',
    '已退款': 'Refunded',
    '版型费': 'Pattern Fee',
    '纸质版型订单': 'Paper Pattern Orders',
    '快递商': 'Courier',
    '开通成功提示': 'Activated. Please re-login.',
    '请选择需要开通的会员订单': 'Select membership order',
    '该订单已支付不能修改': 'Order paid, cannot edit',
    '修改成功': 'Updated',
    '订单已分配提示': 'Order already assigned',
    '您已成功接单': 'Order accepted',
    '订单未付款不能发货': 'Unpaid, cannot ship',
    '订单已退款不能发货': 'Refunded, cannot ship',
    '订单已作废不能发货': 'Voided, cannot ship',
    '请填写物流信息': 'Enter logistics info',
    '订单已发货提示': 'Shipped',
    '正在下载文件中': 'Downloading...',
    '售后退款': 'After-sales Refund',
    '退回': 'Return',
    '生产商统一提供': 'Provided by manufacturer',
    '请输入生产商': 'Enter manufacturer',
    '客户姓名手机号订单号': 'Name/Phone/Order No.',
    '智能量体订单': 'Smart Measure Order',
    '匹配范围': 'Range',
    '运费': 'Shipping',
    '成衣预售订单': 'Pre-sale Orders',
    '缺少收件人信息': 'Missing receiver info',
    '订单作废成功': 'Order voided!',
    '请选择是否同意退款': 'Select agree or reject!',
    '售后退款标签': 'After-sales Refund',
    '后台退款备注': 'Backend refund, note:',
    '成衣现货订单': 'Ready-to-wear Orders',
    '高震服装设计': 'Gaozhen Design',
    '分店': 'Branch',
    '饰品退款': 'Accessory Refund',
    '邮寄费': 'Shipping Fee',
    '设计师': 'Designer',
    '接单时间': 'Accept Time',
    '发起时间': 'Create Time',
    '服务时间': 'Service Time',
    '加码订单号': 'Sub Order No.',
    '点击复制': 'Copy',
    '点击下载': 'Download',
    '未打印': 'Not Printed',
    '回复内容不能为空': 'Reply cannot be empty!',
    '没有发现售后订单': 'No after-sales orders found',
    '派单成功': 'Dispatched!',
    '该机构当日接单数量已超限': 'Daily order limit reached.',
    '账号已停用或绑定错误': 'Account disabled or binding error.',
    '请设置发货人信息': 'Set sender info',
    '上传成功': 'Uploaded',
    '的订单已发货': "'s orders shipped!",
    '饰品订单': 'Accessory Orders',
    '量体定制订单': 'Custom Tailored Orders',
    '输入': 'Enter ',
    '自动匹配，匹配范围：': ' auto match, range: ',
    '已退款标签': 'Refunded',
    '退款商品:': 'Refund Product:',
    '货物状态:': 'Goods Status:',
    '退款原因:': 'Refund Reason:',
    '退款金额:': 'Refund Amt:',
    '退款说明:': 'Refund Note:',
    '相关图片:': 'Photos:',
    '会员开通支付订单': 'Membership Orders',
    '支付金额': 'Amount',
    '订单数':'Order Count',
    您当前没有待审核的:'You currently have no pending ',
    '操作人': 'Operator',
    '订单时间': 'Order Time',
    '操作时间': 'Operate Time',
    '订单类别': 'Category',
    '优惠金额': 'Discount',
    '客户名称': 'Customer',
    '升级级别': 'Level',
    '级别周期': 'Period',
    '级别结束时间': 'End Time',
    '可下载次数': 'Downloads',
    '平台金额': 'Platform Amt',
    '待向平台支付并开通会员': 'Pay to activate membership',
    '价格修改记录': 'Price History',
    '修改人': 'Modified By',
    '修改时间': 'Modified Time',
    '会员下单': 'Member Order',
    '会员升级充值订单': 'Membership Orders',
    '级别开始时间': 'Start Time',
    '】码新增成功': '] size added',
    
    一键引用: 'One-click Quote',
    
    上平台: 'To Platform',
    上平台售卖审核: 'Platform Sales Audit',
    
    上级成衣: 'Upper Garments',
    上级版型: 'Upper Patterns',
    上级辅料: 'Upper Accessories',
    
    '个产品的上架操作。': ' products listed.',
    '个产品的下架操作。': ' products delisted.',
    二级分店: 'Branch Store',
    '二级分店:': 'Branch Store:',
    产品类别: 'Product Category',
    会员价: 'Member Price',
    '会员价:': 'Member Price:',
    会员价格: 'Member Price',
    
    供应商列表: 'Supplier List',
    
    保存绑定: 'Save Binding',
    
    修改为: 'Change to:',
    修改密码: 'Change Password',
    修改成衣量体定制价格: 'Edit Custom Price',
    修改成衣颜色: 'Edit Garment Color',
    修改订单价格: 'Edit Order Price',
    修改记录: 'Edit History',
    
    全不选: 'Deselect All',
    
    分店上下架: 'Store List/Delist',
    分店代码: 'Store Code',
    分店分销至其它分店: 'Distribute to Stores',
    分店名称: 'Store Name',
    
    分销价: 'Wholesale',
    分销价格: 'Wholesale Price',
    
    分销数: 'Dist. Count',
    
    删除引用: 'Delete Quote',
    
    加码: 'Add Size',
    
    单位: 'Unit',
    
    博克文件价格: 'BOKE File Price',
    原价: 'Original',
    
    原始密码: 'Old Password:',
    
    原订单价格: 'Original Price:',
    
    品牌名称: 'Brand Name',
    商品价格: 'Product Price',
    
    商品分类: 'Product Category',
    商品图片: 'Product Images',
    商品基本信息: 'Basic Info',
    商品描述: 'Description',
    
    商品标题: 'Product Title',
    商品款号: 'Product Model',
    商品类别: 'Product Category',
    商品详情: 'Product Details',
    
    '审核人：': 'Auditor:',
    审核受理中不可编辑: 'Under review, cannot edit',
    
    审核时间: 'Audit Time',
    审核结果: 'Audit Result',
    审核记录: 'Audit Record',
    
    审核通过: 'Approved',
    小程序APPID: 'Mini App APPID:',
    小程序Secret: 'Mini App Secret:',
    尺码类型: 'Size Type',
    '尺码表类别:': 'Size Chart:',
    已完成: 'Completed',
    已审核不可编辑: 'Approved, cannot edit',
    已引用: 'Quoted',
    已绑定面料: 'Bound Fabrics',
    平台成衣: 'Platform Garments',
    平台版型库: 'Platform Pattern Library',
    平台辅料: 'Platform Accessories',
    平台面料: 'Platform Fabrics',
    平台饰品: 'Platform Decorations',
    开启预售: 'Enable Presale',
    '开启预售:': 'Presale:',
    开放时间: 'Open Time',
    开通: 'Activate',
    开通成衣量体定制: 'Enable Garment Custom',
    开通指引: 'Setup Guide',
    待确认: 'Pending',
    微信支付公钥ID: 'WeChat Pay Public Key ID:',
    微信支付公钥文件: 'WeChat Pay Public Key File:',
    微信支付参数获取指引: 'WeChat Pay Parameter Guide',
    微信支付商户ID: 'WeChat Pay Merchant ID:',
    微信支付密钥: 'WeChat Pay Key',
    微信支付证书: 'WeChat Pay Cert:',
    微信支付证书号: 'WeChat Pay Cert No:',
    微信服务号APPID: 'WeChat Service Account APPID',
    成本价: 'Cost',
    成本价格: 'Cost Price',
    成衣: 'Garment',
    '成衣【': 'Garment [',
    成衣信息: 'Garment Info',
    '成衣描述:': 'Garment Desc:',
    成衣标题: 'Garment Title',
    成衣款号: 'Garment Model',
    成衣添加尺码: 'Garment size added',
    '成衣生产成本价：': 'Production Cost:',
    成衣范围: 'Garment Range',
    成衣预售: 'Garment Presale',
    所有成衣: 'All Garments',
    所有版型: 'All Patterns',
    所有辅料: 'All Accessories',
    
    扫码绑定成功: 'Scan & Bind Success',
    批量引用平台版型: 'Batch Quote Patterns',
    指导价: 'Guide Price',
    改价: 'New Price',
    文件大小不能超过2M: 'File max 2M',
    新密码: 'New Password:',
    无法修改价格: 'Cannot modify price',
    时间: 'Time',
    '是否上架:': 'Listed:',
    '是否共享给平台:': 'Share to Platform:',
    是否引用: 'Quote',
    昵称: 'Nickname',
    暂无面料: 'No fabrics',
    暂无饰品: 'No decorations',
    
    '最晚发货时间:': 'Latest Ship:',
    最晚发货时间不能早于预售时间: 'Ship date cannot be earlier than presale',
    服装定制: 'Custom Clothing',
    服装尺码: 'Clothing Size',
    '服装尺码:': 'Size:',
    服装标题: 'Garment Title',
    服装编号: 'Garment Code',
    '服装编号:': 'Garment Code:',
    '服装配饰:': 'Accessories:',
    '服装面料:': 'Fabric:',
    '服装颜色:': 'Color:',
    服装风格: 'Clothing Style',
    '服装饰品:': 'Decoration:',
    未引用: 'Not Quoted',
    本店成衣: 'Store Garments',
    本店版型: 'Store Patterns',
    本店辅料: 'Store Accessories',
    
    来源门店: 'Source Store',
    正在生成二维码: 'Generating QR Code...',
    浏览: 'Browse',
    添加: 'Add',
    添加二级分销分店: 'Add Branch',
    添加分店: 'Add Store',
    添加成衣: 'Add Garment',
    添加成衣颜色: 'Add Garment Color',
    添加辅料: 'Add Accessory',
    添加辅料颜色: 'Add Accessory Color',
    点击确定开始引用平台产品: 'Click confirm to quote',
    版型: 'Pattern',
    版型上架: 'Pattern Listing',
    版型上架时间: 'Pattern Listing Time',
    版型分销价格: 'Pattern Wholesale',
    版型定制: 'Pattern/Custom',
    '生产尺码:': 'Prod. Size:',
    '生产面料:': 'Prod. Fabric:',
    申请时间: 'Apply Time',
    申请详情: 'Application Details',
    申请门店: 'Apply Store',
    
    登录账号: 'Login Account',
    确定引用: 'Confirm Quote',
    确认删除该引用吗: 'Delete this quote?',
    '确认删除该引用吗，一旦删除产品将会自动下架，相关订单也会受到影响，确认删除吗？': 'Delete quote? Products will be delisted and orders affected.',
    确认并上架: 'Confirm & List',
    
    绑定公众号: 'Bind Account',
    绑定公众号接收消息提醒: 'Bind for message alerts',
    绑定微信公众号: 'Bind WeChat Account',
    绑定成衣数: 'Bound Garments',
    绑定版型: 'Bind Pattern',
    绑定饰品: 'Bind Decoration',
    '结果：': 'Result:',
    
    订单状态为: 'Order status is',
    设置封面: 'Set Cover',
    '该成衣所有尺码均已添加，无需再加码。': 'All sizes already added.',
    '请勾选成衣尺码!': 'Select garment size!',
    请在此录入成衣描述: 'Enter garment desc here',
    请在此录入辅料描述: 'Enter accessory desc here',
    请在此录入面料描述: 'Enter fabric desc here',
    请录入会员价格: 'Enter member price',
    '请录入会员价格!': 'Enter member price!',
    请录入分销价格: 'Enter wholesale price',
    '请录入分销价格!': 'Enter wholesale price!',
    请录入制作价格: 'Enter production price',
    '请录入制作价格!': 'Enter production price!',
    请录入原始密码: 'Enter old password',
    请录入商户ID: 'Enter merchant ID',
    请录入微信支付密钥: 'Enter WeChat Pay key',
    请录入成本价格: 'Enter cost price',
    请录入成衣款号: 'Enter garment model',
    请录入最晚发货时间: 'Enter latest ship date',
    请录入服务号APPID: 'Enter service account APPID',
    请录入服装分类: 'Enter clothing category',
    '请录入服装分类!': 'Enter clothing category!',
    请录入服装尺码: 'Enter clothing size',
    请录入服装标题: 'Enter garment title',
    
    '请录入服装颜色!': 'Enter garment color!',
    请录入服装风格: 'Enter clothing style',
    
    请录入证书: 'Enter certificate',
    请录入辅料会员价格: 'Enter accessory member price',
    请录入辅料分销价格: 'Enter accessory wholesale price',
    请录入辅料名称: 'Enter accessory name',
    请录入辅料成本价格: 'Enter accessory cost',
    请录入辅料描述: 'Enter accessory desc',
    '请录入辅料标题!': 'Enter accessory title!',
    请录入辅料款号: 'Enter accessory model',
    请录入辅料销售价格: 'Enter accessory sale price',
    '请录入辅料颜色!': 'Enter accessory color!',
    
    请录入销售单位: 'Enter sales unit',
    
    请录入面料会员价格: 'Enter fabric member price',
    请录入面料分类: 'Enter fabric category',
    请录入面料分销价格: 'Enter fabric wholesale price',
    请录入面料单位: 'Enter fabric unit',
    请录入面料名称: 'Enter fabric name',
    
    请录入面料宽度: 'Enter fabric width',
    请录入面料成本价格: 'Enter fabric cost',
    请录入面料描述: 'Enter fabric desc',
    
    请录入面料款号: 'Enter fabric model',
    
    请录入面料销售价格: 'Enter fabric sale price',
    请录入面料颜色: 'Enter fabric color',
    
    请录入预售时间: 'Enter presale date',
    
    '请确认是否上架!': 'Confirm listing!',
    '请确认是否共享给平台!': 'Confirm share to platform!',
    
    请输入款号标题查询: 'Enter model/title',
    
    '请输入编码、系统编码、辅料标题查询': 'Enter code/accessory title',
    
    请输入编码系统编码成衣标题查询: 'Enter code/garment title',
    请输入编码系统编码标题查询: 'Enter code/title',
    请输入编码系统编码版型标题查询: 'Enter code/pattern title',
    '请选择二级分店!': 'Select branch store!',
    请选择商品类别: 'Select product category',
    
    '请选择服装分类!': 'Select clothing category!',
    请选择需要批量引用的服装类别: 'Select category for batch quote',
    
    请选择面料分类: 'Select fabric category',
    
    账号信息: 'Account Info',
    
    购买: 'Buy',
    辅料上架: 'Accessory Listing',
    辅料信息: 'Accessory Info',
    '辅料单位:': 'Unit:',
    辅料名称: 'Accessory Name',
    辅料平台上架: 'Platform Listing',
    辅料描述: 'Accessory Desc',
    辅料新增成功: 'Accessory added',
    '辅料标题:': 'Title:',
    辅料款号: 'Accessory Model',
    辅料添加颜色: 'Add Color',
    '辅料编号:': 'Code:',
    辅料范围: 'Accessory Range',
    辅料颜色: 'Accessory Color',
    '辅料颜色:': 'Color:',
    
    输入关键字查询版型: 'Search patterns',
    
    输入面料商开始筛选: 'Enter fabric supplier to filter',
    
    退出登录: 'Logout',
    适应季节: 'Season',
    
    选择门店: 'Select Store',
    
    销售价格: 'Sale Price',
    
    销售单位: 'Sales Unit',
    
    销量: 'Sales',
    门店: 'Store',
    零售价: 'Retail',
    
    面料下架: 'Fabric Delisted',
    
    面料分类: 'Fabric Category',
    面料列表: 'Fabric List',
    面料单位: 'Fabric Unit',
    
    面料宽度: 'Fabric Width',
    面料描述: 'Fabric Desc',
    
    面料查询: 'Fabric Search',
    面料标题: 'Fabric Title',
    
    面料款号: 'Fabric Model',
    面料颜色: 'Fabric Color',
    预估用量: 'Est. Usage',
    预售: 'Presale',
    预售成衣: 'Presale Garments',
    '预售时间:': 'Presale:',
    风格: 'Style',
    饰品列表: 'Decoration List',
    饰品商: 'Decoration Supplier',
    饰品查询: 'Decoration Search',
    开始: 'Start',
    添加结点: 'Add Node',
    面辅料审核: 'Fabric Audit',
    共享审核: 'Shared Audit',
    合规性审核: 'Compliance Audit',
    更新审核设置: 'Update Audit Settings',
    审核状态: 'Audit Status',
    版型成衣选择: 'Pattern/Garment',
    审核: 'Audit',
    申请单号: 'Form No.',
    申请事项: 'Subject',
    制作价格: 'Production Price',  
    原因: 'Reason',
    请录入审核不通过的原因: 'Enter rejection reason',
    请选择审核结果: 'Select audit result',
    审核成功: 'Audit OK',
    您当前没有待审核的共享版型: 'No pending shared patterns.',
    您当前没有待审核的面辅料: 'No pending fabrics.',
    您当前没有待审核的饰品: 'No pending accessories.',
    您当前没有待审核的引用版型: 'No pending reference patterns.',
    辅料: 'Material',
    面辅料选择: 'Fabric/Material',
    基本信息: 'Basic Info',
    产品编号: 'Product Code',
    产品描述: 'Product Desc',
    面料图片: 'Fabric Images',
    饰品基本信息: 'Accessory Info',
    饰品标题: 'Accessory Title',
    饰品编号: 'Accessory Code',
    饰品描述: 'Accessory Desc',
    饰品图片: 'Accessory Images',
    下发门店: 'Store',
    尺码行数: 'Size Rows',
    发布时间: 'Publish Time',
    智能版型: 'Smart Pattern',
    提交时间: 'Submit Time',
    成衣尺码: 'Garment Size',
    自营: 'Self-run',
    蓝迪云平台: 'Landi Cloud',
    引用审核: 'Reference Audit',
    面辅料:'fabrics',
     '未审核': 'Pending',
    '已拒绝': 'Refused',
    '驳回': 'Reject',
    '请选择审核结果!': 'Please select audit result!',
    '驳回原因': 'Reject Reason',
    '请输入驳回原因': 'Enter reject reason',
    '续期开始时间': 'Renewal Start',
    '续期结束时间': 'Renewal End',
    '会员续期审核': 'Member Renewal Audit',
    '收入类别': 'Income Category',
    '会员编号': 'Member ID',
    '收入金额': 'Income Amount',
    '收入项目': 'Income Item',
    '项目代码': 'Item Code',
    '可用': 'Active',
    '新增账户充值信息': 'Add Recharge Info',
    '录入充值金额': 'Enter recharge amount',
    '录入说明详情': 'Enter description',
    '新增成功': 'Added',
    '客户姓名/手机号': 'Customer Name/Phone',
    '总本金金额': 'Total Principal',
    '总赠送金额': 'Total Gift',
    '续费周期': 'Renewal Cycle',
    '付款方式': 'Payment',
    '微信': 'WeChat',
    '支付宝': 'Alipay',
    '提现': 'Withdraw',
    '待提现': 'Pending',
    '已完结': 'Completed',
    '执行提现': 'Execute Withdrawal',
    '提现收款账号': 'Withdrawal Account',
    '提现金额': 'Amount',
    '提现申请人': 'Applicant',
    '提现申请时间': 'Apply Time',
    '执行人': 'Executor',
    '执行时间': 'Execute Time',
    '提现状态': 'Status',
    '执行': 'Execute',
    '提现账号': 'Withdrawal Account',
    '开户行': 'Bank',
    '账号名称': 'Account Name',
    '银行卡号': 'Card No.',
    '提现额度': 'Amount',
    '请线下将钱款打入对方账号后，再进行此操作。': 'Please transfer offline before confirming.',
    '打款完成': 'Payment Done',
    '提现执地成功': 'Withdrawal Success',
    '全部商品': 'All Products',
    '饰品': 'Ornament',
    '入库编号': 'Inbound No.',
    '单价': 'Price',
    '商品类型': 'Product Type',
    '入库数量': 'Inbound Qty',
    '最新库存数量': 'Current Stock',
    '入库原因': 'Inbound Reason',
    '新进货入库': 'New Purchase',
    '盘盈入库': 'Stock Gain',
    '其他入库': 'Other Inbound',
    '出库编号': 'Outbound No.',
    '出库数量': 'Outbound Qty',
    '出库原因': 'Outbound Reason',
    '出库时间': 'Outbound Time',
    '销售出库': 'Sales',
    '盘亏出库': 'Stock Loss',
    '损耗出库': 'Damage',
    '出库': 'Outbound',
    '入库': 'Inbound',
    '出入记录': 'Records',
    '未上架': 'Offline',
    '已上架': 'Online',
    '出入库详情': 'Inventory Details',
    '手动出库': 'Manual Outbound',
    '当前库存数': 'Current Stock',
    '输入出库数量': 'Enter outbound qty',
    '选择出库原因': 'Select reason',
    '添加库存': 'Add Stock',
    '新入库数量': 'New Inbound Qty',
    '输入入库数量': 'Enter inbound qty',
    '选择入库原因': 'Select reason',
    '其它入库': 'Other Inbound',
    '请输入出库原因！': 'Please enter outbound reason!',
    '请输入出库数量': 'Please enter outbound qty',
    '请输入入库原因！': 'Please enter inbound reason!',
    '请输入入库数量': 'Please enter inbound qty',
    '入库成功': 'Inbound Success',
    '单价(元)': 'Price(CNY)',
    '出入数量': 'Qty Change',
    '当前数量': 'Current Qty',
    '操作类型': 'Type',
    '操作人员': 'Operator',
    '是否启用': 'Enabled',
    '站内通知': 'Notification',
    '请录入站内通知!': 'Please enter notification!',
    '站内通知：一行为一条，轮询通知。': 'One notification per line, displayed in rotation.',
    '新增类别': 'Add Category',
    '辅料分类': 'Accessory',
    '饰品分类': 'Ornament',
    '确定要删除这个项目吗？': 'Delete this item?',
    '确定删除': 'Confirm Delete',
    '添加子项': 'Add Sub Item',
    '使用中': 'In Use',
    '父编码': 'Parent Code',
    '录入父编码': 'Enter parent code',
    '类型名称': 'Type Name',
    '录入类型名称': 'Enter type name',
    '排序码': 'Sort Code',
    '录入排序码': 'Enter sort code',
    '父编号': 'Parent ID',
    '关联数量': 'Related Count',
    '最近修改时间': 'Last Modified',
    '新增尺码': 'Add Size',
    '模板名称': 'Template Name',
    '蓝迪云尺码': 'Landy Size',
    '加盟商尺码': 'Franchisee Size',
    '保留尺码': 'Reserved Size',
    '被使用数': 'Usage Count',
    '绑定数量': 'Binding Count',
    '关联大类': 'Related Category',
    '用途分类': 'Usage Type',
    '创建人': 'Creator',
    '新增分组': 'Add Group',
    '导入': 'Import',
    '尺码名称': 'Size Name',
    '录入类型简码': 'Enter code',
    '尺码类别': 'Size Type',
    '尺码分组': 'Size Group',
    '请录入尺码关联大类': 'Select related category',
    '版型系统': 'Pattern System',
    '量体系统': 'Measure System',
    '成衣系统': 'Garment System',
    '系统尺码': 'System Size',
    '自定义尺码': 'Custom Size',
    '尺码删除成功': 'Size deleted',
    '删除成功。': 'Deleted.',
    '新增成功。': 'Added.',
    '请选择关联尺码大类。': 'Please select related size category.',
    '尺码新增成功。': 'Size added.',
    '尺码编辑成功。': 'Size updated.',
    '新增服装类别': 'Add Clothing Category',
    '尺码详情': 'Size Details',
    '只显示定制需要参数': 'Show custom params only',
    '仅显示命名尺码(新规格不显示)': 'Named sizes only',
    '保存参数': 'Save Params',
    '全新导入': 'Fresh Import',
    '另存为模板': 'Save as Template',
    '导入模板': 'Import Template',
    '参数设置': 'Param Settings',
    '必要': 'Required',
    '主要': 'Primary',
    '次要': 'Secondary',
    '占位': 'Placeholder',
    '没有尺码数据': 'No size data',
    '主次要': 'Priority',
    '模板名称：': 'Template Name:',
    '给当前模板命个名吧': 'Name this template',
    '模板导入发生错误！': 'Template import error!',
    '模板名称已存在！': 'Template name exists!',
    '导入成功': 'Imported',
    '尺码重新导入成功。': 'Size re-imported.',
    '尺码保存成功。': 'Size saved.',
    '新增服装风格': 'Add Style',
    '风格名称': 'Style Name',
    '简码': 'Code',
    '引用数': 'Ref Count',
    '确定删除吗': 'Confirm delete?',
    '新增课程': 'Add Course',
    '课程封面': 'Cover',
    '课程级别': 'Level',
    '课程价格': 'Price',
    '课程长度': 'Duration',
    '请录入课程名称!': 'Enter course name!',
    '初级': 'Beginner',
    '中级': 'Intermediate',
    '高级': 'Advanced',
    '请选择课程级别!': 'Select course level!',
    '课程时长': 'Duration',
    '请录入课程时长!': 'Enter duration!',
    '小时': 'Hours',
    '请录入课程价格!': 'Enter price!',
    '课程简介': 'Description',
    '请录入课程简介!': 'Enter description!',
    '课程目录': 'Catalog',
    '上传PDF': 'Upload PDF',
    '删除PDF': 'Delete PDF',
    '试看课程视频': 'Preview Video',
    '新增充值': 'Add Recharge',
    '新增父类目': 'Add Parent',
    '输入消息内容进行检索': 'Search message content',
    '只显示系统消息': 'System messages only',
    '聊天消息': 'Chat',
    '系统消息': 'System',
    '其它消息': 'Others',
    '发送者': 'Sender',
    '消息内容': 'Content',
    '消息类型': 'Type',
    '发送时间': 'Send Time',
    '消息详情': 'Message Detail',
    '新增单位': 'Add Unit',
    '单位名称': 'Unit Name',
    '事件名称': 'Event',
    '发生地点': 'Location',
}
